// ** Type Import
import { OwnerStateThemeType } from "../";
import { Theme, alpha } from "@mui/material/styles";
import { gridClasses } from "@mui/x-data-grid-premium";

const ODD_OPACITY = 0.2;

const DataGrid = () => {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          //   backgroundColor: theme.palette.background.default,
          //   boxShadow: boxShadow(theme),
          //   color: theme.palette.text.primary,
          //   borderColor: theme.palette.divider,
          //   "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
          //     outline: "none",
          //   },
          //   "& .MuiDataGrid-pinnedColumnHeaders": {
          //     // backgroundColor: theme.palette.customColors.tableHeaderBg,
          //   },
          //   "& .MuiDataGrid-pinnedColumnHeaders, & .MuiDataGrid-pinnedColumns": {
          //     // backgroundColor: theme.palette.customColors.tableHeaderBg,
          //     boxShadow: "none !important",
          //     backgroundImage: "none",
          //   },
          // ! Styles taken from "StyledDataGrid" (what we had already applied)
          maxHeight: "inherit",
          border: "none",
          // when you click the filters and click away - it hides the header text - fixed by changing overflow on header div
          "& .MuiDataGrid-columnHeaderTitleContainerContent": {
            overflow: "visible",
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: theme.palette.background.default,
          },
          "& .MuiDataGrid-columnHeader:hover": {
            backgroundColor: theme.palette.grey[100],
            "& .filterButton": {
              visibility: "visible",
            },
          },
          "& .MuiDataGrid-scrollArea": {
            minWidth: "150px",
          },
          "& .MuiDataGrid-scrollArea--left": {
            background: "linear-gradient(to right, rgba(124, 152, 179, 0.4), rgba(124, 152, 179, 0.3), rgba(124, 152, 179, 0.3), rgba(124, 152, 179, 0))",
          },
          "& .MuiDataGrid-scrollArea--right": {
            background: "linear-gradient(to right, rgba(124, 152, 179, 0), rgba(124, 152, 179, 0.3), rgba(124, 152, 179, 0.3), rgba(124, 152, 179, 0.4))",
          },
          "& .MuiDataGrid-cellContent": {
            display: "flex",
            alignItems: "center",
            height: "100%",
            width: "100%",
            position: "relative",
          },

          "& .MuiDataGrid-row--dynamicHeight": {
            minHeight: "53px",
          },
          // v7 pinned cells are sticky and paint their own background over the row - inherit the row's striping/highlight
          // like the v6 pinned columns did, including on hover since rows have no hover effect (selected rows keep MUI's
          // opaque pinned selected styles). The :hover selectors out-rank MUI's pinned-only hover background
          [[
            `& .${gridClasses.virtualScrollerContent} .${gridClasses.row}:not(.Mui-selected) .${gridClasses["cell--pinnedLeft"]}`,
            `& .${gridClasses.virtualScrollerContent} .${gridClasses.row}:not(.Mui-selected) .${gridClasses["cell--pinnedRight"]}`,
            `& .${gridClasses.virtualScrollerContent} .${gridClasses.row}:not(.Mui-selected):hover .${gridClasses["cell--pinnedLeft"]}`,
            `& .${gridClasses.virtualScrollerContent} .${gridClasses.row}:not(.Mui-selected):hover .${gridClasses["cell--pinnedRight"]}`,
          ].join(", ")]: {
            backgroundColor: "inherit",
          },
          // v7 draws a separator after the left pinned section (cells, header and empty-area filler) - v6 had none
          [[
            `& .${gridClasses["cell--pinnedLeft"]}.${gridClasses["cell--withRightBorder"]}`,
            `& .${gridClasses["columnHeader--pinnedLeft"]}.${gridClasses["columnHeader--withRightBorder"]}`,
            `& .${gridClasses["filler--pinnedLeft"]}`,
          ].join(", ")]: {
            borderRight: "none",
          },
          // the empty space below the last row uses MUI's grey pinned background - match the white virtual scroller
          [`& .${gridClasses["filler--pinnedLeft"]}, & .${gridClasses["filler--pinnedRight"]}`]: {
            backgroundColor: theme.palette.common.white,
          },
          "& .MuiDataGrid-cell": {
            padding: "0 !important",
          },
          // bold grouped tree data column .MuiDataGrid-cell

          '& .MuiDataGrid-cell[data-field="__tree_data_group__"]': {
            fontWeight: "bold !important",
          },
          "& .MuiDataGrid-selectedRowCount": {
            visibility: "hidden",
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none !important",
          },
          "& .MuiDataGrid-virtualScroller": {
            minHeight: "60px",
            backgroundColor: theme.palette.common.white,
          },
          "& .MuiDataGrid-cell--editable:hover": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-cell--editable": { cursor: "pointer" },
          "& .MuiDataGrid-menuIcon": { display: "none !important" },
          "& .MuiDataGrid-cell.Mui-selected": {
            border: "1px solid #1976d2 !important",
            borderRadius: "1px",
          },
          [`& .${gridClasses.row}.odd:not(.Mui-selected)`]: {
            backgroundColor: theme.palette.grey[50],
          },
          [`& .${gridClasses.row}.even:not(.Mui-selected)`]: {
            backgroundColor: theme.palette.common.white,
          },
        }),
        // ! Other overrides which we may want to use or move from styleOverrides to one of these instead
        // toolbarContainer: ({ theme }: OwnerStateThemeType) => ({
        //   paddingRight: `${theme.spacing(5)} !important`,
        //   paddingLeft: `${theme.spacing(3.25)} !important`,
        // }),
        // columnHeaders: ({ theme }: OwnerStateThemeType) => ({
        //   borderRadius: 0,
        // }),
        // columnHeader: ({ theme }: OwnerStateThemeType) => ({
        //   "&:not(.MuiDataGrid-columnHeaderCheckbox)": {
        //     paddingLeft: theme.spacing(4),
        //     paddingRight: theme.spacing(4),
        //     "&:first-of-type": {
        //       paddingLeft: theme.spacing(5),
        //     },
        //   },
        //   "&:last-of-type": {
        //     paddingRight: theme.spacing(5),
        //   },
        // }),
        // columnHeaderCheckbox: {
        //   maxWidth: "58px !important",
        //   minWidth: "58px !important",
        // },
        // columnHeaderTitleContainer: {
        //   padding: 0,
        // },
        // columnHeaderTitle: {
        //   fontWeight: 600,
        //   fontSize: "0.75rem",
        //   letterSpacing: "0.17px",
        //   textTransform: "uppercase",
        // },
        // columnSeparator: ({ theme }: OwnerStateThemeType) => ({
        //   color: theme.palette.divider,
        // }),
        // row: ({ theme }: OwnerStateThemeType) => ({
        // "&:last-child": {
        //   "& .MuiDataGrid-cell": {
        //     borderBottom: 0,
        //   },
        // },
        // }),
        // cell: ({ theme }: OwnerStateThemeType) => ({
        //   borderColor: theme.palette.divider,
        //   "&:not(.MuiDataGrid-cellCheckbox)": {
        //     paddingLeft: theme.spacing(4),
        //     paddingRight: theme.spacing(4),
        //     "&:first-of-type": {
        //       paddingLeft: theme.spacing(5),
        //     },
        //   },
        //   "&:last-of-type": {
        //     paddingRight: theme.spacing(5),
        //   },
        //   "&:focus, &:focus-within": {
        //     outline: "none",
        //   },
        // }),
        // cellCheckbox: {
        //   maxWidth: "58px !important",
        //   minWidth: "58px !important",
        // },
        // editInputCell: ({ theme }: OwnerStateThemeType) => ({
        //   padding: 0,
        //   color: theme.palette.text.primary,
        //   "& .MuiInputBase-input": {
        //     padding: 0,
        //   },
        // }),
        // footerContainer: ({ theme }: OwnerStateThemeType) => ({
        //   borderTop: `1px solid ${theme.palette.divider}`,
        //   "& .MuiTablePagination-toolbar": {
        //     paddingLeft: `${theme.spacing(4)} !important`,
        //     paddingRight: `${theme.spacing(4)} !important`,
        //   },
        //   "& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel": {
        //     color: theme.palette.text.primary,
        //   },
        // }),
        // selectedRowCount: ({ theme }: OwnerStateThemeType) => ({
        //   margin: 0,
        //   paddingLeft: theme.spacing(4),
        //   paddingRight: theme.spacing(4),
        // }),
      },
    },
  };
};

export default DataGrid;
